import type { IntentMode } from './types';

/**
 * Async intent detection.
 *
 * This is intentionally a mock implementation. This will be replaced
 * with a real API call via @atlassian/search-client.
 */
export const detectIntentMock = async (_inputQuery: string): Promise<IntentMode> => {
	return Math.random() > 0.5 ? 'ALL_APPS' : 'JIRA_WORK_ITEMS';
};
